export default __webpack_public_path__ + "static/media/RobertByirigiro.b7c67b17.webp";